module.exports = __webpack_public_path__ + "img/AutoIncrement.ad2aeeaa.svg";